import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Литература. 6 класс",
        subject: "Особенности изучения юмористических рассказов А.П. Чехова",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Особенности изучения юмористических рассказов А.П. Чехова",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Шамчикова Валентина Максимовна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории филологического общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>В настоящее время школы работают в условиях внедрения обновлённого ФГОС ООО, который отличается практической направленностью и нацеливает обучающихся на достижение не только предметных, но и личностных, метапредметных результатов.  </p>"
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem; padding-top: 0'>Вместе с тем одна из важных составляющих изучения литературы – это работа школьников с теоретико-литературными понятиями. </p>
                                    `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Как соединить практику с теорией? Какие сложности могут ждать учителя литературы на пути достижения учениками планируемых результатов и освоения ими необходимых теоретико-литературных понятий?</p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Известно, что выполнение заданий, которые нацелены на проверку усвоения теоретико-литературных понятий, вызывает у обучающихся трудности: школьники показывают недостаточно высокие результаты. </p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Почему у шестиклассников возникают сложности с пониманием, например, такого понятия как «юмор»? Ребята с удовольствием знакомятся с юмористическими рассказами, смеются над героями, комичными ситуациями и с удовольствием читают такие произведения, ведь им интересно, и кажется, что всё понятно. Однако они не могут ответить на вопросы, как писатель создаёт комический эффект, какие приёмы использует, почему одни произведения вызывают улыбки, смех, а другие нет. В результате возникают пробелы в анализе художественных произведений, которые необходимо восполнить.</p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Понятие «юмор» впервые включено в предметные результаты для 6 класса в ФОП ООО в части ФРП ООО (предмет «Литература»). Школьники должны научиться «понимать смысловое наполнение теоретико-литературных понятий и учиться использовать их в процессе анализа и интерпретации произведений, оформления собственных оценок и наблюдений». В содержание федеральной рабочей программы в курс 6 класса входят юмористические рассказы А.П. Чехова, изучая которые и постигая тайны создания комического, шестиклассники должны достигнуть планируемых результатов. </p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Как получить нужный результат, какая методическая работа будет способствовать освоению школьниками теоретико-литературного понятия «юмор» и одновременному достижению ими не только предметных результатов, но и личностных и метапредметных? </p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Такая задача раньше не ставилась, поэтому у учителей литературы могут возникнуть трудности в преподавании, а у обучающихся – в достижении планируемых результатов.  </p>
                                   `
                        },
                        {
                            type: "block",
                            text: `<p style='padding-left: 2.4rem;'>Вспомним сначала, что включает теоретико-литературное понятие «юмор», и попробуем разобраться, какое значение юмор имеет в рассказах А.П. Чехова, представленных в курсе литературы 6 класса.  </p>
                                   `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Горская О.Ю. Обучение пониманию и созданию юмористического текста на уроках словесности // Материалы Всероссийской научно-практической конференции «Наука и социум», 2020 [Электронный ресурс.] URL:   https://cyberleninka.ru/article/n/obuchenie-ponimaniyu-i-sozdaniyu-yumoristicheskogo-teksta-na-urokah-slovesnosti (дата обращения: 29. 08. 2023 г.)",
                "Гурвич И. Проза Чехова (человек и действительность). – Москва: Высшая школа, 1990",
                "Катаев В.Б. Сложность простоты. Рассказы и пьесы Чехова. – 4-е изд. – Москва: Изд-во МГУ; Самара: Учеб. лит., 2004",
                "Косолобова И.В. Лингвокогнитивные механизмы создания комического в ранней прозе А.П. Чехова, 2006 [Электронный ресурс.] URL: https://www.dissercat.com/content/lingvokognitivnye-mekhanizmy-sozdaniya-komicheskogo-v-rannei-proze-ap-chekhova (дата обращения: 29. 08. 2023 г.)",
                "Костина И.Б. Литература в школе. 5-11 классы. Изучение рассказов А. П. Чехова: этапы, содержание, технологии. – Волгоград: Учитель, 2023",
                "Крайчик Л. Е. Поэтика комического в произведениях А. П. Чехова: монография / Л. Е. Крайчик; научн. ред. Б. Т. Удодов, 1986",
                "Пранцова Г.Е., Романичева Е.С. Современные стратегии чтения: теория и практика. Смысловое чтение и работа с текстом: учебное пособие. – 2 изд., испр. и доп. – Москва: ФОРУМ, 2015 ",
                "Преподавание русского языка и литературы в условиях обновления содержания школьного образования: методическое пособие/ Ускова И. В., Шамчикова В. М., Макаров М. И.; под ред. И. В. Усковой. – Москва: ФГБНУ «Институт стратегии развития образования РАО», 2021. [Электронный ресурс.] URL: https://edsoo.ru/GOTOVITSYa_K_PUBLIKACII_Prepodavanie_russkogo_yazika_i_literaturi_v_usloviyah_obnovleniya_soderzhaniya_shkolnogo_obrazovaniya.htm (дата обращения: 29. 08. 2023 г.)",
            ],
            sites: [],
            filesToDownload: [
                {
                    link: "./files/additional1.pdf",
                    fileName: "Вопросы и задания к рассказам"
                },
                {
                    link: "./files/additional2.pdf",
                    fileName: "Памятка, как написать рассказ"
                }
            ]
        }
    ],
};